<template>
  <div class="section">
    <div class="section-title">
      <p>{{ title }}</p>
      <p v-if="legend" class="section-legend">{{ legend }}</p>
      <div class="section-line"></div>
    </div>
    <div class="section-content"><slot></slot></div>
  </div>
</template>

<style lang="scss" scoped>
.section {
  display: flex;

  .section-title {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    color: #000000;

    width: 200px;
    padding-right: 20px;

    display: flex;
    flex-direction: column;

    .section-legend {
      font-family: Roboto;
      font-weight: normal;
      font-size: 12px;
      color: #6d7587;

      margin-top: 5px;
    }

    .section-line {
      flex-grow: 1;
      margin-top: 10px;
      border-left: 1px solid #acbacc;
    }
  }

  .section-content {
    width: 100%;
  }
}
</style>

<script>
export default {
  name: 'TsFormSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    legend: {
      type: String,
      default: ''
    }
  }
};
</script>
